import allowances from './models/AllowancesHelper';

export default { allowances };
